import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import TaskList from './TaskList';
import TaskHistory from './TaskHistory';
import Metrics from './Metrics';
import Meetings from './Meetings';
import CreateTask from './CreateTask';

function SlackTasks() {
  return (
    <Routes>
      <Route path="" element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="tasks" element={<TaskList />} />
      <Route path="history" element={<TaskHistory />} />
      <Route path="metrics" element={<Metrics />} />
      <Route path="meetings" element={<Meetings />} />
      <Route path="create" element={<CreateTask />} />
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
}

export default SlackTasks;
